// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/hulk-trips'

/** Strips the leading slash so a route can be used as a relative <Navigate> target. */
export const relative = (route: string) => route.replace(/^\//, '')

export const BaseHulkTripsAreaRoutes = {
  route: baseRoute,
  Vehicles: {
    route: '/vehicles',
  },
  Templates: {
    route: '/templates',
    Create: {
      route: '/create',
    },
    Edit: {
      route: '/:templateId/edit',
    },
  },
}

export const HulkTripsAreaRoutes = transformRoutes(BaseHulkTripsAreaRoutes)
